import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { ICopyDocumentExecutorProps } from './ICopyDocumentExecutorProps';
import { CopyDocumentExecutorModal } from './CopyDocumentExecutorModal';

export const CopyDocumentExecutor = createDocModalExecutor<ICopyDocumentExecutorProps>({
    modal: CopyDocumentExecutorModal,
    defaultModalSize: 'l',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        title: action.options?.title ?? '',
        message: action.options?.message ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
